// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MPPr6dcB_a5GtSFv6S7d {
  position: relative;
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.DtNQnUuJT9FgsVPT4G12 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  margin-top: -74px;
}

.lXnXMcaFkg7Q3twj4OPn{
  position: absolute;
  top: 60%;
  left: 40%;
  transform: translate(-50%, -50%);
}

.ujNjoo0B5KEagNuYY3Qx {
  margin-top: 20px;
  padding: 10px;
  width: 95%;
}

.WvkDA0nToCbuEB25jSW_ {
  background-color: #fff;
  margin-bottom: 20px;
  border-bottom: 1px solid #ddd;
  padding: 25px 25px;
  border-radius: 12px;
}

.WvkDA0nToCbuEB25jSW_:last-child {
  border-bottom: none;
}

.DtNQnUuJT9FgsVPT4G12 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  margin-top: -13px;
}

.PKrZkZKEi5cYgKM1LQ40 {
  display: flex;
  align-items: center;
  gap: 12px;
}

.Z8tIZcO3oby7iVR8MS6w {
  display: flex;
  gap: 10px;
}

.Z8tIZcO3oby7iVR8MS6w img {
  cursor: pointer;
  width: 20px;
  height: 20px;
}

.VlPGCx3ft208qROEaFoz {
  display: flex;
  align-items: center;
  gap: 10px;
}

.COI7q996PEsu8oCUzZqA {
  font-size: 14px;
  font-weight: 400;
  color: black;
  background-color: rgba(245, 245, 245, 1);
  padding: 6px 12px;
  border-radius: 16px;
}

.SiRO8uiU1Gi8QbSch0j1 {
  width: 20px;
  height: 20px;
  background-color: rgba(245, 245, 245, 1);
  padding: 5px;
  border-radius: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.y9SIiUlEh6L5Yf63Dur6 h3 {
  font-size: 18px;
  color: rgba(0, 75, 160, 1);
  margin-bottom: 5px;
}

.y9SIiUlEh6L5Yf63Dur6 p {
  font-size: 16px;
  color: rgba(77, 77, 77, 1);
  margin: 0;
}

.qHyTE8FKk_nRmiRxFCe4 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 26%;

}

.XENv8uUpYhz0N0a7UyLI {
  width: 80px;
  height: 80px;
  margin-bottom: 15px;
  opacity: 0.8;
}

.myjDM7QQqYEDtIWRwBtr {
  font-size: 16px;
  color: rgba(142, 142, 142, 1);
  text-align: center;
  line-height: 1.5;
}

`, "",{"version":3,"sources":["webpack://./src/home/css/myquestions.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,wCAAwC;EACxC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;;AAEjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".myQuestionsContainer {\n  position: relative;\n  padding: 20px;\n  background-color: #f5f5f5;\n  min-height: 100vh;\n}\n\n.questionHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  margin-top: -74px;\n}\n\n.mobileLoader{\n  position: absolute;\n  top: 60%;\n  left: 40%;\n  transform: translate(-50%, -50%);\n}\n\n.questionList {\n  margin-top: 20px;\n  padding: 10px;\n  width: 95%;\n}\n\n.questionItem {\n  background-color: #fff;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #ddd;\n  padding: 25px 25px;\n  border-radius: 12px;\n}\n\n.questionItem:last-child {\n  border-bottom: none;\n}\n\n.questionHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n  margin-top: -13px;\n}\n\n.dateAndActions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.actions {\n  display: flex;\n  gap: 10px;\n}\n\n.actions img {\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n}\n\n.answersSection {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.answersCount {\n  font-size: 14px;\n  font-weight: 400;\n  color: black;\n  background-color: rgba(245, 245, 245, 1);\n  padding: 6px 12px;\n  border-radius: 16px;\n}\n\n.copylink {\n  width: 20px;\n  height: 20px;\n  background-color: rgba(245, 245, 245, 1);\n  padding: 5px;\n  border-radius: 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.questionContent h3 {\n  font-size: 18px;\n  color: rgba(0, 75, 160, 1);\n  margin-bottom: 5px;\n}\n\n.questionContent p {\n  font-size: 16px;\n  color: rgba(77, 77, 77, 1);\n  margin: 0;\n}\n\n.noQuestionsContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 26%;\n\n}\n\n.noQnsIcon {\n  width: 80px;\n  height: 80px;\n  margin-bottom: 15px;\n  opacity: 0.8;\n}\n\n.noQuestionsText {\n  font-size: 16px;\n  color: rgba(142, 142, 142, 1);\n  text-align: center;\n  line-height: 1.5;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"myQuestionsContainer": `MPPr6dcB_a5GtSFv6S7d`,
	"questionHeader": `DtNQnUuJT9FgsVPT4G12`,
	"mobileLoader": `lXnXMcaFkg7Q3twj4OPn`,
	"questionList": `ujNjoo0B5KEagNuYY3Qx`,
	"questionItem": `WvkDA0nToCbuEB25jSW_`,
	"dateAndActions": `PKrZkZKEi5cYgKM1LQ40`,
	"actions": `Z8tIZcO3oby7iVR8MS6w`,
	"answersSection": `VlPGCx3ft208qROEaFoz`,
	"answersCount": `COI7q996PEsu8oCUzZqA`,
	"copylink": `SiRO8uiU1Gi8QbSch0j1`,
	"questionContent": `y9SIiUlEh6L5Yf63Dur6`,
	"noQuestionsContainer": `qHyTE8FKk_nRmiRxFCe4`,
	"noQnsIcon": `XENv8uUpYhz0N0a7UyLI`,
	"noQuestionsText": `myjDM7QQqYEDtIWRwBtr`
};
export default ___CSS_LOADER_EXPORT___;
